import { useAppSelector } from 'hooks/reduxHooks'
import getLoyaltyBenefitAvailability from 'loyalty/lib/determineLoyaltyBenefitAvailability'
import { useMemo } from 'react'

interface LoyaltyUserBenefitView {
  benefit: App.LoyaltyBenefit
  availability: number
}

/**
 * Retrieves the users current benefit for the type given
 * @returns The benefit, or nothing if they don't have it
 */
function useLoyaltyUserBenefitView(
  /** The benefit type to retrieve */
  benefitType: App.LoyaltyBenefitType,
): LoyaltyUserBenefitView | undefined {
  const userBenefits = useAppSelector(state => state.loyalty.account.data?.benefits)
  return useMemo<LoyaltyUserBenefitView | undefined>(() => {
    const benefit = userBenefits?.find(benefit => benefit.code === benefitType)
    if (!benefit) return
    return {
      benefit,
      availability: getLoyaltyBenefitAvailability(benefit)
    }
  }, [benefitType, userBenefits])
}

export default useLoyaltyUserBenefitView
